import {FC, useContext, useEffect, useState} from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {checkIsActive, KTIcon, WithChildren} from '../../../helpers'
import {useLayout} from '../../core'
import { PathContext } from '../../../../app/pages/Employees/componenets/AddEmployee/user-context/path-context/PathContext'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
}

const AsideMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
}) => {
  const {pathname} = useLocation()
  const isActive = checkIsActive(pathname, to)
  const {config} = useLayout()
  const {aside} = config
  const pathAddEmployee = "/hr/employee/add-employee/personal-details";
  const pathEditEmployee="/hr/employee/list-employees";
  // Destructure the context to get the global state and updater functions
  const { isPathMatched, setIsPathMatched } = useContext(PathContext)
 const  {isPathMatchedEditEmployee, setIsPathMatchedEditEmployee}=useContext(PathContext)
  // UseEffect to check if the current path matches and update localStorage accordingly
  useEffect(() => {
    // Check if the current path matches the add-employee path
    if (pathname === pathAddEmployee) {
      setIsPathMatched(true) // Set the state to true when the path matches
      localStorage.setItem("pathMatched", "showAddEmployeeMenu") // Store the value in localStorage
    } else {
      setIsPathMatched(false) // Reset the state if the path doesn't match
      localStorage.removeItem("pathMatched") // Remove the item from localStorage
    }
  }, [pathname, setIsPathMatched, pathAddEmployee])
  useEffect(() => {
      // Check if the current path matches the add-employee path
      if (pathname === pathEditEmployee) {
        setIsPathMatchedEditEmployee(true);
        localStorage.setItem("pathMatchedEditEmployeeMenu", "showEditEmployeeMenu") // Store the value in localStorage
      } else {
        localStorage.removeItem("pathMatchedEditEmployeeMenu") // Remove the item from localStorage
        setIsPathMatchedEditEmployee(false);
      }
  }, [pathname,setIsPathMatchedEditEmployee,pathEditEmployee])
  return (
    <div className='menu-item'>
      <Link className={clsx('menu-link without-sub', {active: isActive})} to={to}>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && aside.menuIcon === 'svg' && (
          <span className='menu-icon'>
            <KTIcon iconName={icon} className='fs-2' />
          </span>
        )}
        {fontIcon && aside.menuIcon === 'font' && <i className={clsx('bi fs-3', fontIcon)}></i>}
        <span className={`${(
          pathname === "/hr/reports/attendance" ||
          pathname === "/hr/reports/leave" ||
          pathname === "/hr/reports/employee-shift-hours" ||
          pathname === "/hr/reports/employee-leave-balance" ||
          pathname ==="/hr/reports/employee-contact-details" ||
          pathname === "/hr/reports/employee-details" 
        ) ? "title-report" : "menu-title"}`}>
          {title}
        </span>
      </Link>
      {children}
    </div>
  )
}

export {AsideMenuItem}
